module.exports = __webpack_public_path__ + "img/bianca-piriz.e24391bb.jpg";